import React, { useEffect, useState } from "react";
import {
    Box,
    Fab,
    TextField,
    Button,
    List,
    ListItem,
    ListItemText,
    Typography,
    Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { useSelector } from "react-redux";

export default function ChildDevelopmentSuggestions({ reportId, parentSuggestions }) {

    console.log('reportId', reportId)

    const token = useSelector((state) => state.auth.user?.jwt);

    const [suggestions, setSuggestions] = useState([]);
    const [newSuggestion, setNewSuggestion] = useState("");
    const [adding, setAdding] = useState(false);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setSuggestions(parentSuggestions)
    }, [parentSuggestions])

    const handleAddClick = () => {
        setAdding(true);
    };

    const handleSaveClick = async () => {
        if (!newSuggestion.trim()) return;

        const suggestionObj = {
            id: Date.now(),
            text: newSuggestion,
            date: new Date().toISOString(),
        };

        const updatedSuggestions = [suggestionObj, ...suggestions];

        setLoading(true);
        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/reports/update-parent-suggestions/${reportId}`,
                updatedSuggestions,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            setSuggestions(updatedSuggestions);
            setNewSuggestion("");
            setAdding(false);
        } catch (err) {
            console.error("Błąd zapisu sugestii:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Paper sx={{ p: 3, mx: "auto" }} elevation={0}>

            <List>
                {suggestions?.length > 0 ? (
                    suggestions?.map((s) => (
                        <ListItem key={s.id} sx={{ mb: 1, bgcolor: "grey.100", borderRadius: 1 }}>
                            <ListItemText
                                primary={s.text}
                                secondary={`Dodano: ${new Date(s.date).toLocaleString()}`}
                            />
                        </ListItem>
                    ))
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        Brak sugestii
                    </Typography>
                )}
            </List>

            {adding && (
                <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
                    <TextField
                        fullWidth
                        label="Wpisz sugestię"
                        value={newSuggestion}
                        onChange={(e) => setNewSuggestion(e.target.value)}
                    />
                    <Button variant="contained" onClick={handleSaveClick} disabled={loading}>
                        Zapisz
                    </Button>
                </Box>
            )}

            {!adding && (
                <Fab color="primary" aria-label="add" sx={{ mt: 2 }} onClick={handleAddClick}>
                    <AddIcon />
                </Fab>
            )}
        </Paper>
    );
}
